export const isExw = (selectedCountry) => {
    return selectedCountry === "other";
}